module.exports = __webpack_public_path__ + "img/imgZXGH(14).8cb4c2fb.png";